import { createSelector } from 'reselect'
import { selectCurrentTicketId } from 'selectors/tickets/current'
import { selectRawTicket } from 'selectors/tickets/byId'
import { emptyObj } from 'util/objects'
import { emptyArr } from 'util/arrays'

const storeKey = 'drafts2'

export const selectById = state => state[storeKey].byId || emptyObj

export const selectRawDraftsByTicketId = state => {
  return state[storeKey].byTicketId || emptyObj
}

export const selectByMessageId = state =>
  state[storeKey].byMessageId || emptyObj

export const selectDraftIdByTicketId = (state, ticketId, type) => {
  const byTicketId = selectRawDraftsByTicketId(state)
  const draftIdSet = byTicketId[ticketId]
  return draftIdSet ? draftIdSet[type] : null
}

export const selectDraftByTicketId = (state, ticketId, type) => {
  const draftId = selectDraftIdByTicketId(state, ticketId, type)
  if (draftId) return selectById(state)[draftId] || null
  return null
}

export const selectDraftBodyByTicketId = (state, ticketId, type) => {
  const found = selectDraftByTicketId(state, ticketId, type)
  return found ? found.body : null
}

export const selectDraftById = (state, draftId) => {
  return selectById(state)[draftId] || null
}

export const selectDraftBodyByDraftId = (state, draftId) => {
  const found = selectDraftById(state, draftId)
  return found ? found.body : null
}

export const selectDraftPropByDraftId = (state, draftId, prop) => {
  const found = selectDraftById(state, draftId)
  return found ? found[prop] : null
}

export const selectAttachmentsByDraftId = (state, draftId) => {
  const found = selectDraftById(state, draftId)
  return found ? found.attachmentsNormalized : emptyArr
}

export const selectDraftPropOrDefault = (state, draftId, ticketId, prop) => {
  const found = selectDraftById(state, draftId)
  if (found) return found[prop]

  const ticket = selectRawTicket(state, ticketId)
  const defaults = ticket.draftDefaults
  const value = defaults ? defaults[prop] : null
  return value
}

export const makeDraftPropOrDefaultSelector = (state, draftId, ticketId) => {
  return prop => selectDraftPropOrDefault(state, draftId, ticketId, prop)
}

export const selectDraftIsSynced = (state, draftId) => {
  const draft = selectDraftById(state, draftId)
  if (!draft) return null
  return draft.version === draft.serverVersion
}

const selectCurrentTicketDraftId = createSelector(
  selectCurrentTicketId,
  selectRawDraftsByTicketId,
  (ticketId, byTicketId) => byTicketId[ticketId]
)

export const selectCurrentTicketHasDraft = createSelector(
  selectCurrentTicketDraftId,
  draftId => !!draftId
)
